<template>
  <!-- <modal width="35" :show-modal="showModal" @close-modal="$emit('close-modal')"> -->
  <modal width="35" :show-modal="showModal" >
    <div
      class="flex my-4 flex-col text-right gap-4 items-center justify-center"
    >
      <p class="font-semibold px-8 text-center">
        Confirm you want to send a Handoff Receipt Request To:
      </p>
      <div class="flex justify-between w-100">
        <div>
          <p class="text-lightGrey">3PL Terminal</p>
          <p>
            {{
              processObj.receivingShippingService ? processObj.receivingShippingService.orgName : "N/A"
            }}
          </p>
        </div>
       
        <div class="w-32">
          <p class="text-lightGrey">Name</p>
          <p>{{ processObj.receiver.contactName }}</p>
        </div>
      </div>
      <div class="flex justify-between w-100">
        <div>
          <p class="text-lightGrey">Phone Number</p>
          <p>{{ processObj.receiver.mobile }}</p>
        </div>
        <div class="w-32">
          <p class="text-lightGrey">Address</p>
          <!-- <p>{{ formatAddress(booking.shipperlocation.address) }},</p> -->
           <p>{{
              processObj.receivingShippingService && processObj.receivingShippingService.takeOffTerminal  &&   processObj.receivingShippingService.takeOffTerminal.address   ?   processObj.receivingShippingService.takeOffTerminal.address : "N/A"
            }}</p>
        </div>
      </div>
      <div class="flex justify-between w-100">
        <div>
          <p class="text-lightGrey">State</p>
          <p>
            {{
              processObj.receivingShippingService && processObj.receivingShippingService.takeOffTerminal  &&   processObj.receivingShippingService.takeOffTerminal.state   ?   processObj.receivingShippingService.takeOffTerminal.state : "N/A"
            }}
          </p>
        </div>
        <div class="w-32">
          <p class="text-lightGrey">Email</p>
          <p>{{processObj.receiver.email }}</p>
        </div>
      </div>
      <div class="flex justify-between w-100">
        <div>
          <p class="text-lightGrey">Delivery Status</p>
          <p class="text-[#09B78A]   status-text">{{processObj.deliveryStatus}}</p>
        </div>
        <!-- <div class="w-32">
          <p class="text-lightGrey">Receipt code</p>
          <p>*******</p>
        </div> -->
      </div>

      <div class="button-wrapper">
        <div>
          <base-button
            text="Confirm"
            :loading="loading"
            @click="sendProcess()"
          />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  components: {},
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    booking: {
      type: Object,
      required: true,
    },
    processObj: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showRequestSentModal: false,
      loading: false,
    };
  },
  methods: {
    async sendProcess() {
      // let user = this.$store.state.authentication.user;
      // let sender = {
      //   firstname: user.firstname,
      //   lastname: user.lastname,
      //   email: user.email,
      //   mobile_no: user.mobile_no,
      // };

      // let postMessage = {
      //   app: "muleex",
      //   event: "process:handoff",
      //   message: {
      //     module: "shippings",
      //     moduleId: this.booking.id,
      //     origin: {
      //       userId: this.processObj.fromUserId,
      //       orgId: this.processObj.fromOrgid,
      //       sender,
      //     },
      //     destination: {
      //       userId: this.processObj.toUserId,
      //       orgId: this.processObj.toOrgId,
      //     },
      //     orgReceiver: this.processObj.orgReceiver,
      //     booking: {
      //       shippingId: this
      //       .booking.shippingReference,
      //       consolidationId:
      //         this
      //         .booking?.consolidations?.consolidationReference,
      //       shippingService: this
      //       .booking?.shippingservice?.orgName,
      //       forwarding3pl: {
      //         companyname:
      //           this.$store.state.authentication.organizationDetails
      //             .companyname,
      //         mobile_no:
      //           this.$store.state.authentication.organizationDetails.mobile_no,
      //       },
      //       receiver: {
      //         name: this
      //         .booking?.consigneelocation.contactName,
      //         mobile_no: this
      //         .booking?.consigneelocation.mobile,
      //         address: this.booking?.consigneelocation.address,
      //       },
      //     },
      //     user: this.processObj.userObj,
      //     location: this.processObj.locationObj,
      //   },
      // };
      // this.$socket.emit("makeMessage", postMessage);

      this.$emit("show-request-sent");
      this.closeModal();
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.status-text{
  color:#09B78A ;
}
.delete-modal {
  text-align: center;
}

p {
  text-align: left;
}
</style>
